var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23193 11.25H11.7319M7.52284 2.0985C7.52284 2.0985 7.52284 3.05203 8.47637 4.00556C9.4299 4.95909 10.3834 4.95909 10.3834 4.95909M3.75172 9.49304L5.75413 9.20698C6.04297 9.16572 6.31064 9.03189 6.51696 8.82557L11.337 4.00556C11.8636 3.47894 11.8636 2.62512 11.337 2.0985L10.3834 1.14497C9.85682 0.618345 9.00299 0.618345 8.47637 1.14497L3.65636 5.96498C3.45005 6.17129 3.31621 6.43896 3.27495 6.7278L2.98889 8.73022C2.92532 9.1752 3.30673 9.55661 3.75172 9.49304Z",
    stroke: "#9CA3AF",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen2);
export default __webpack_public_path__ + "static/media/edit-pen-2.897bcd07.svg";
export { ForwardRef as ReactComponent };